import { dismissNotification } from 'containers/App/actions'

export default {
  dismissNotification,
}
